export { default as FaqBottomSheet } from './FaqBottomSheet.vue';
